export const PoweredBy = () => {
  return (
    <p className='text-center text-xs text-gray-500'>
      <a href='https://boxyhq.com/' target='_blank' rel='noopener noreferrer'>
        Powered by BoxyHQ
      </a>
    </p>
  );
};
